<template>
    <div class="hiq-calendar__filters--date">
        <h2 class="hiq-calendar__filters--heading">{{translations.timePeriod}}</h2>
        <button class="hiq-calendar__filters--toggle-button hiq-filter-button" @click="showDatePicker = !showDatePicker" aria-controls="hiq-calendar__filters--date__inputs" :aria-expanded="showDatePicker ? 'true' : 'false'">
            {{translations.date}}
        </button>
        <div v-show="showDatePicker" class="hiq-calendar__filters--date__inputs" id="hiq-calendar__filters--date__inputs">
            <label>
                {{translations.fromDate}}
                <input type="date" v-model="startDate" :max="endDate">
            </label>
            <label>
                {{translations.toDate}}
                <input type="date" v-model="endDate" :min="startDate">
            </label>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import { newSearch } from '../../store/actions';
export default Vue.extend({
    name: 'date-filter',
    data() {
        return { 
            showDatePicker: false,
        }
    },
    methods: {
        setDate(value, isStart) {
            this.$store.commit({
                type: isStart ? 'setStartDate' : 'setEndDate',
                payload: value
            });
            this.$store.commit({
                type: 'setPage',
                payload: 1
            });
            this.$store.dispatch(newSearch());
        }
    },
    computed: {
        translations() {
            return this.$store.state.translations;
        },
        startDate: {
            get() {
                return this.$store.state.filter.startDate;
            },
            set(val) {
                this.setDate(val, true)
            }
        },
        endDate: {
            get() {
                return this.$store.state.filter.endDate;
            },
            set(val) {
                this.setDate(val, false)
            }
        }
    },
    mounted() {
        if(this.$store.state.filter.endDate || this.$store.state.filter.startDate) {
            this.showDatePicker = true;
        }
    }
})
</script>